import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ParamContext } from '../../service/param.context';
import { SERVER_API_URL } from '../../../environment.constants';
import { EnableSavingIndicator } from '../../loading-indicator';


// Assuming you have an observation interface
export interface StudyEntryObservation {
    stockId: number;
    variableId: number;
    value: string;
    categoricalValueId: number;
}

@Injectable({
    providedIn: 'root'
})
export class StudyEntryObservationService {
    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {

    }

    addObservation(studyId: number, studyEntryObservation: StudyEntryObservation): Observable<number> {
        const baseUrl = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies`;
        return this.http.post<number>(`${baseUrl}/${studyId}/observations`, studyEntryObservation, { context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    updateObservation(studyId: number, studyEntryObservation: StudyEntryObservation): Observable<any> {
        const baseUrl = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies`;
        return this.http.patch(`${baseUrl}/${studyId}/observations`, studyEntryObservation, { context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    deleteObservation(studyId: number, observationId: number): Observable<any> {
        const baseUrl = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies`;
        return this.http.delete(`${baseUrl}/${studyId}/observations/${observationId}`, { context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    countObservationsByVariables(studyId: number, variableIds: number[]): Observable<HttpResponse<any>> {
        const baseUrl = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies`;
        const params = new HttpParams().set('variableIds', variableIds.join(','));
        return this.http.head(`${baseUrl}/${studyId}/observations`, { observe: 'response' , params });
    }

}
